var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import cx from "clsx";
import { CategoryButton } from "./CategoryButton";
import { CategoryPanel } from "./CategoryPanel";
import { toggleCategoryState } from "./helpers";
import { Column } from "../Column";
export var Category = function (_a) {
    var children = _a.children, title = _a.title, categoryIndex = _a.categoryIndex, currentCategory = _a.currentCategory, setCurrentCategory = _a.setCurrentCategory, setHasCategoryOpen = _a.setHasCategoryOpen;
    var isPanelWide = children.length > 2;
    var isOpen = categoryIndex === currentCategory;
    var panelClass = cx({
        "cat-wide-left w-full md:w-240": isPanelWide,
        "cat-narrow-left md:w-172": !isPanelWide,
        "cat-panel-open max-h-240": isOpen,
        "cat-panel-closed max-h-0": !isOpen,
    });
    var columnsWidthClass = "w-full md:w-68 md:first:w-78 md:last:w-94";
    return (React.createElement(React.Fragment, null,
        React.createElement(CategoryButton, { className: "cat-button", title: title, onClick: function () {
                return toggleCategoryState({
                    categoryIndex: categoryIndex,
                    setCurrentCategory: setCurrentCategory,
                    currentCategory: currentCategory,
                    setHasCategoryOpen: setHasCategoryOpen,
                });
            }, isOpen: isOpen }),
        React.createElement(CategoryPanel, { className: panelClass }, children.map(function (col, index) { return (React.createElement(Column, __assign({}, col, { key: index, className: columnsWidthClass }))); }))));
};
//# sourceMappingURL=Category.js.map